import { SizingStatus } from "@/types";

/**
 * SDCP-1325: sizing has three real outcomes, so the badge has three colours.
 *
 * Passed is green and Failed is red. Everything else — pending manual review, and a project
 * whose sizing has never been run — reads amber, which is what SDCP-1338 established for a
 * non-pass before a distinct Failed state existed.
 */
export const getSizingBadgeVariant = (sizingStatus?: SizingStatus | null) => {
  if (sizingStatus === "passed") {
    return { success: true };
  }
  if (sizingStatus === "failed") {
    return { danger: true };
  }
  return { yellow: true };
};
